export const getUrlParameter = (name: string) => {
	name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]")
	const regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
	const results = regex.exec(window.top!.location.search) // eslint-disable-line
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "))
}

export const downloadBase64Content = (base64: string, fileName: string, fileType: string) => {
	const byteCharacters = atob(base64)
	const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i))
	const byteArray = new Uint8Array(byteNumbers)
	const file = new Blob([byteArray], { type: fileType })
	const blobUrl = (window.webkitURL || window.URL).createObjectURL(file)
	const anchor = document.createElement("a")
	anchor.download = fileName
	anchor.href = blobUrl
	anchor.dataset.downloadurl = [fileType, anchor.download, anchor.href].join(":")
	anchor.click()
	setTimeout(() => {
		URL.revokeObjectURL(blobUrl)
	}, 1000)
}
